/* globals ResponsiveUtil */

import { component } from 'common/util/ComponentDecorator';
import HistoryUtil from 'common/util/HistoryUtil';
import './product-header.scss';

@component
export default class ProductHeader {
	static classname = 'product-header';

	constructor($header) {
		this.$header = $header;

		if (ResponsiveUtil.isDesktopUp()) {
			this.bindEvents();
			this.bindGlobalEvents();

			this.init();
		}

	}

	get is_always_visible() {
		return this.$header.hasClass('product-header_always-visible');
	}

	get is_disabled_observer() {
		return this.$header.data('is-disabled-observer') == 1;
	}

	get height() {
		return this.$header.height();
	}

	get $targets() {
		return $('[data-scroll-target]');
	}

	get $menu_items() {
		return this.$header.find('.product-header__menu-item');
	}

	set active(id) {
		/*this.$menu_items.filter('.product-header__menu-item_active').removeClass('product-header__menu-item_active');
		this.$menu_items.filter(`.product-header__menu-item[data-id="${id}"]`).addClass('product-header__menu-item_active');*/

		this.scrollTo(id);
	}

	get$Target(id) {
		return this.$targets.filter(`[data-scroll-target="${id}"]`);
	}

	get$TargetOffset(id) {
		if (!this.get$Target(id).length) {
			return 0;
		}

		return this.get$Target(id).offset().top - this.height;
	}

	isActiveByScroll(id) {
		const offset = this.get$TargetOffset(id);
		if (!offset) {
			return false;
		}

		return window.pageYOffset > offset - 100;
	}

	init() {
		if (!this.is_disabled_observer) {
			this.handleScroll();

			if (!HistoryUtil.isReload()) {
				const id = location.hash.substr(1);
				if (id.length > 0) {
					if (this.get$Target(id).length) {
						this.scrollTo(id);
					}
				}
			}
		}
	}

	bindEvents() {
		if (!this.is_disabled_observer) {
			this.$menu_items.on('click', this.handleClickMenuItem);
		}
	}

	bindGlobalEvents() {
		if (!this.is_disabled_observer) {
			$(window).on('scroll', this.handleScroll);
		}
	}

	scrollTo(id) {
		ScrollUtil.scrollTo(this.get$Target(id).offset().top - this.height - 50);
	}

	handleScroll = () => {
		const is_fixed = window.pageYOffset > this.start_offset_y;

		const self = this;
		let active = false;
		this.$targets.each(function () {
			const id = $(this).data('scroll-target');

			if (self.isActiveByScroll(id)) {
				active = true;
				self.$menu_items.filter('.product-header__menu-item_active').removeClass('product-header__menu-item_active');
				self.$menu_items.filter(`.product-header__menu-item[data-id="${id}"]`).addClass('product-header__menu-item_active');
			}
		});

		if (!this.is_always_visible) {
			this.$header.toggleClass('product-header_visible', active);
		}
	};

	handleClickMenuItem = e => {
		const { currentTarget: target} = e;
		if (location.pathname === target.pathname) {
			e.preventDefault();
		} else {
			if (this.get$Target(target.dataset.id).length) {
				e.preventDefault();
			} else {
				return;
			}
		}

		this.active = target.dataset.id;
	};
}
